import angular from 'angular'

import myAxletreeForm from './directives/forms/myAxletreeForm'
import myAxletreesForm from './directives/forms/myAxletreesForm'
import myAxletreesEditForm from './directives/forms/myAxletreesEditForm'

import axletreeIcons from './resources/icons.resource'
import axletreeFields from './resources/fields.resource'
import axletreeLabels from './resources/labels.resource'

import axletreeAsk from './services/ask.service'
import axletreeFormat from './services/format.service'
import axletreeGo from './services/go.service'
import axletreeLocal from './services/local.service'
import axletreeMetadata from './services/metadata.service'
import axletreeResource from './services/resource.service'
import axletreeRequest from './services/request.service'
import axletree from './services/axletree.service'

const name = 'axletree'

angular.module(name, [])
  .directive('myAxletreeForm', myAxletreeForm)
  .directive('myAxletreesForm', myAxletreesForm)
  .directive('myAxletreesEditForm', myAxletreesEditForm)
  .factory('axletreeLabels', axletreeLabels)
  .factory('axletreeFields', axletreeFields)
  .factory('axletreeIcons', axletreeIcons)

  .factory('axletreeAsk', axletreeAsk)
  .factory('axletreeFormat', axletreeFormat)
  .factory('axletreeGo', axletreeGo)
  .factory('axletreeLocal', axletreeLocal)
  .factory('axletreeMetadata', axletreeMetadata)
  .factory('axletreeResource', axletreeResource)
  .factory('axletreeRequest', axletreeRequest)
  .factory('$$axletree', axletree)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/axletree.module.js